import { AppBar, Box, IconButton, Toolbar, Button } from '@mui/material'
import UserMenu from '../../components/Shared/UserMenu'
import React, {useState} from 'react'
import BreadCrumbs from '../Main/BreadCrumbs'
import { MenuOutlined } from '@mui/icons-material'
import NotificationMenu from '../../components/Shared/NotificationMenu'
import BalanceBar from '../../components/Bank/BalanceBar'
import SelectedCondo from "../../components/Shared/SelectedCondo";
import UnitUserBreadCrumbs from "./UnitUserBreadCrumbs";
import UnitUserMenu from "./UnitUserMenu";

const drawerWidth = 250

const HeaderUnitUser = ({ handleDrawerToggle }) => {
  const [req, setReq] = useState(null)

  return (
    <Box sx={{ mb: 10 }}>
      <AppBar
        position={'fixed'}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          bgcolor: 'white',
          boxShadow: 'rgb(32 32 32 / 6%) 0px 8px 16px;',
        }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <IconButton
            color="primary"
            aria-label="Abrir Barra"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuOutlined/>
          </IconButton>
          <UnitUserBreadCrumbs/>
          <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
            {/*<SelectedCondo />*/}
            {/*<Box*/}
            {/*  onClick={() => setReq(prevState => !prevState)}*/}
            {/*  >*/}
            {/*  <BalanceBar req={req}/>*/}
            {/*</Box>*/}
            {/*<NotificationMenu/>*/}
            <UnitUserMenu/>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
export default HeaderUnitUser
